import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { hydrateSessionFromLogin, isAuth, restoreSession } from "../helper/auth";
import { clearAuthToken } from "../helper/authCookie";
import swal from "sweetalert";
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

function LoginUser() {
    const user = isAuth();
    const nav = useNavigate();
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            let u = isAuth();
            if (!u) u = await restoreSession();
            if (cancelled || !u) return;
            if (u.role === "admin") nav("/admin");
            else if (u.role === "staff") nav("/dashboard");
        })();
        return () => { cancelled = true; };
    }, [nav]);

    const loginHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post('api/auth/login-user', {
                username,
                password
            }, { withCredentials: true });

            if (response.data.user?.role === "staff" && response.data.token) {
                clearAuthToken();
                hydrateSessionFromLogin(response.data.user, response.data.token);
                window.location.assign('/dashboard');
                return;
            }

            swal("Gagal", "Username atau Password salah!", "error");
        } catch (err) {
            const message = err?.response?.data?.message || "Username atau Password salah!";
            swal("Gagal", Array.isArray(message) ? message.join(', ') : message, "error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen bg-zafu-cream flex items-center justify-center px-4 py-10">
            <div className="w-full max-w-4xl grid md:grid-cols-2 rounded-zafu-xl overflow-hidden shadow-zafu-lg bg-white">
                <div className="hidden md:flex flex-col justify-between bg-gradient-to-br from-zafu-green to-zafu-green-soft p-10 text-white">
                    <div>
                        <div className="w-14 h-14 rounded-full bg-zafu-cream text-zafu-green font-display font-bold text-2xl flex items-center justify-center mb-6">
                            Z
                        </div>
                        <p className="text-white/70 text-xs tracking-[0.2em] uppercase mb-2">Zafu Residence</p>
                        <h1 className="font-display text-4xl font-semibold leading-tight mb-3">Absensi Staff</h1>
                        <p className="text-white/80 text-sm leading-relaxed max-w-xs">
                            Catat kehadiran, cek histori, dan lihat rekap jam kerja dengan mudah.
                        </p>
                    </div>
                    <p className="text-white/50 text-xs">©2026 Zafu Residence</p>
                </div>

                <div className="p-8 md:p-10 flex flex-col justify-center">
                    <div className="md:hidden w-12 h-12 rounded-full bg-zafu-green text-zafu-cream font-display font-bold text-xl flex items-center justify-center mb-4">
                        Z
                    </div>
                    <h2 className="font-display text-2xl text-zafu-ink mb-1">Zafu Residence</h2>
                    <p className="text-zafu-muted text-sm mb-6">Login Staff</p>

                    <form onSubmit={loginHandler} className="space-y-4">
                        <div className="zafu-input">
                            <FaUser className="h-4 w-4 text-zafu-green-soft mr-2 shrink-0" />
                            <input
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full outline-none border-none bg-transparent text-base"
                                type="text"
                                placeholder="Username"
                                required
                                autoComplete="username"
                            />
                        </div>
                        <div className="zafu-input">
                            <FaLock className="h-4 w-4 text-zafu-green-soft mr-2 shrink-0" />
                            <input
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full outline-none border-none bg-transparent text-base"
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                required
                                autoComplete="current-password"
                            />
                            <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-zafu-muted p-1">
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        <button
                            disabled={loading}
                            type="submit"
                            className="w-full py-3 rounded-zafu bg-zafu-green text-white text-sm font-semibold hover:bg-zafu-green-soft transition-colors disabled:opacity-60"
                        >
                            {loading ? "Memproses..." : "Masuk"}
                        </button>
                    </form>

                    <p className="text-center text-xs text-zafu-muted mt-6">
                        Admin?{" "}
                        <NavLink to="/login-admin" className="text-zafu-green font-medium hover:underline">
                            Login admin
                        </NavLink>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default LoginUser;
